// extracted by mini-css-extract-plugin
export default {"linksBlock":"PageLinks_linksBlock__pWjSF","link":"PageLinks_link__7I49W"};